import React, { useState } from "react";
import "./Monthly.css";

export default function Monthly() {
  const [capitalInput, setCapitalInput] = useState("");
  const [capitals, setCapitals] = useState([10000, 20000, 50000, 100000, 500000]);

  const daysList = [3, 7, 15, 30, 60, 90, 120, 150, 180, 365];

  // Compound calculation (2.5% daily)
  const calculateCompound = (capital, days) => {
    return capital * Math.pow(1 + 0.025, days);
  };

  const handleAdd = () => {
    const value = parseInt(capitalInput);
    if (!isNaN(value) && value > 0) {
      setCapitals([...capitals, value]);
      setCapitalInput("");
    }
  };

  return (
    <div className="monthly-container">
      <h2 className="header">COMPOSITE INDEX 2.5%</h2>

      <div className="input-row">
        <input
          type="number"
          value={capitalInput}
          placeholder="Enter your capital..."
          onChange={(e) => setCapitalInput(e.target.value)}
        />
        <button onClick={handleAdd}>Add</button>
      </div>

      <div className="table-wrapper">
        <div className="table-scale">
          <table className="compound-table">
            <thead>
              <tr>
                <th>CAPITAL</th>
                <th>BONUS 5%</th>
                {daysList.map((d) => (
                  <th key={d}>{d} DAY</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {capitals.map((cap, i) => {
                const bonus = cap * 0.05; // 5% bonus
                const totalCapital = cap + bonus;
                return (
                  <tr key={i}>
                    <td>{cap.toLocaleString()}</td>
                    <td className="bonus">{bonus.toLocaleString()}</td>
                    {daysList.map((d) => (
                      <td key={d}>
                        {Math.floor(calculateCompound(totalCapital, d)).toLocaleString()}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className="note">
        The daily interest rate is <b>2.5%</b>. If you continue to play every day
        without quitting, the amount in your account will double almost every 30
        days. The higher the capital, the higher the profit, the longer the term,
        the higher the compound interest.
      </div>
    </div>
  );
}